<template>
  <div class="order-submission">
    <div
      class="allAddress"
      :style="store_self_mention ? '' : 'padding-top: 0.2rem'"
      v-if="active != 'offline_caigou'"
    >
      <div class="nav acea-row">
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="store_self_mention"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on2'"
          @click="addressType(1)"
          v-if="store_self_mention"
        ></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-if="shipping_type === 0"
        @click="addressTap"
      >
        <div class="addressCon" v-if="addressInfo.real_name">
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.is_default"
              >[默认]</span
            >
            {{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="address acea-row row-between-wrapper" v-else>
        <div class="addressCon">
          <div class="name">
            {{ system_store.name }}
            <span class="phone">{{ system_store.phone }}</span>
          </div>
          <div>
            {{ system_store._detailed_address }}
          </div>
        </div>
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <template v-if="active != 'offline_caigou'">
      <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo" :payType="active"></OrderGoods>
    </template>
    <template v-else>
      <OrderGoodsCaigou :evaluate="0" :cartInfo="orderGroupInfo.cartInfo" :payType="active"></OrderGoodsCaigou>
    </template>
    <div class="wrapper">
      <div
        class="item acea-row row-between-wrapper"
        @click="couponTap"
        v-if="deduction === false && active == 'weixin'"
      >
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <div 
        class="item acea-row row-between-wrapper"
        @click="couponCodeTap"
        v-if="orderGroupInfo.cartInfo.length==1 && orderGroupInfo.cartInfo[0].productInfo.id==71023" 
      >
        <div>优惠码</div>
        <div class="discount">
          {{ couponCode || "使用优惠码" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <div
        class="item acea-row row-between-wrapper" 
        v-if="deduction === false"
        v-show="false"
      >
        <div>积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  当前积分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="
          orderGroupInfo.priceGroup.vipPrice > 0 &&
            userInfo.vip &&
            pinkId == 0 &&
            orderGroupInfo.bargain_id == 0 &&
            orderGroupInfo.combination_id == 0 &&
            orderGroupInfo.seckill_id == 0
        "
      >
        会员优惠
        <div class="discount">￥{{ orderGroupInfo.priceGroup.vipPrice }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0 && active != 'offline_caigou'">
        <div>快递费用</div>
        <div class="discount">
          {{
            orderGroupInfo.priceGroup.storePostage > 0
              ? orderGroupInfo.priceGroup.storePostage
              : "免运费"
          }}
        </div>
      </div>
      <div v-else>
        <div class="item acea-row row-between-wrapper">
          <div>联系人</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系姓名"
              v-model="contacts"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>联系电话</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系电话"
              v-model="contactsTel"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">所在地区</div>
          <div
            class="picker acea-row row-between-wrapper select-value form-control"
          >
            <div class="address">
              <div slot="right" @click.stop="show2 = true">
                {{ model2 || "请选择收货地区" }}
              </div>
              <CitySelect
                v-model="show2"
                :callback="result2"
                :items="district"
                provance="湖南"
                city=""
                area=""
              ></CitySelect>
            </div>
            <!-- <div class="iconfont icon-dizhi font-color-red"></div> -->
          </div>
        </div>
        <div class="item" v-if="active=='offline_caigou'">
          <div>详细地址（具体的乡镇街道地址）</div>
          <textarea
            placeholder="请输具体的乡镇街道地址"
            v-model="address_detail"
          ></textarea>
        </div>
        <div class="item" v-if="active=='offline_caigou'">
          <div>学校名称</div>
          <textarea
            placeholder="请输入完整的学校名称"
            v-model="school_name"
          ></textarea>
        </div>
      </div>
      <div class="item">
        <div>备注信息</div>
        <textarea
          placeholder="备注说明（150字以内）"
          v-model="mark"
        ></textarea>
      </div>
    </div>
    <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin && active != 'offline_caigou'"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="!isWeixin && active != 'offline_caigou'"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
            v-show="false"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              余额支付
            </div>
            <div class="tip">可用余额：{{ userInfo.now_money || 0 }}</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="(offlinePayStatus === 1 && deduction === false)"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              线下支付
            </div>
            <div class="tip">线下方便支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline_tuan' ? 'on' : ''"
            @click="payItem('offline_tuan')"
            v-if="is_tuan === true"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline_tuan' ? 'bounceIn' : ''"
              ></div>
              单位团购
            </div>
            <div class="tip">线下支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline_caigou' ? 'on' : ''"
            @click="payItem('offline_caigou')"
            v-if="is_caigou === true"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline_caigou' ? 'bounceIn' : ''"
              ></div>
              征订采购
            </div>
            <div class="tip">线下支付</div>
          </div>
        </div>
      </div>
    </div>
    <div class="moneyList">
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.total_price !== undefined"
      >
        <div>商品总价：</div>
        <div class="money">￥{{ orderPrice.total_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderGroupInfo.priceGroup.storePostage > 0"
      >
        <div>运费：</div>
        <div class="money">￥{{ orderGroupInfo.priceGroup.storePostage }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.coupon_price > 0"
      >
        <div>优惠券/码抵扣：</div>
        <div class="money">-￥{{ orderPrice.coupon_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deduction_price > 0"
      >
        <div>积分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deduction_price }}</div>
      </div>
    </div>
    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计:
        <span class="font-color-red">￥{{ orderPrice.pay_price }}</span>
      </div>
      <div class="settlement" @click="confirmCreateOrder">立即结算</div>
    </div>
    <CouponCodeWindow
      v-model="showCouponCode"
      @checked="changeCouponCode"
    ></CouponCodeWindow>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #e93323 0%,
    #f5f5f5 100%
  );
  background-image: -moz-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  padding-top: 1rem;
}
.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .allAddress .nav .item {
  width: 3.55rem;
}
.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}
.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}
.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}
.order-submission .allAddress .nav .item.on2 {
  position: relative;
}
.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}
.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}
.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}
.order-submission .address {
  padding: 0px;
}
.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
</style>
<script>
import OrderGoods from "@components/OrderGoods";
import OrderGoodsCaigou from "@components/OrderGoodsCaigou";
import CouponCodeWindow from "@components/CouponCodeWindow";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import District from "ydui-district/dist/jd_province_city_area_id";

const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: {
    OrderGoods,
    CitySelect,
    OrderGoodsCaigou,
    CouponListWindow,
    CouponCodeWindow,
    AddressWindow
  },
  props: {},
  data: function() {
    return {
      show2: false,
      showCouponCode:false,
      couponCode:'',
      model2: "",
      district: District,
      address: {},
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      // active: _isWeixin ? "weixin" : "yue",
      active: _isWeixin ? "weixin" : "weixin",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      is_tuan: false,
      is_caigou: false,
      school_name: "",
      address_detail: ""
    };
  },
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) {
        this.getUserInfo();
        this.getCartInfo();
      }
    },
    shipping_type() {
      this.computedPrice();
    }
  },
  mounted: function() {
    this.$dialog.loading.open('正加载订单信息...');
    let that = this;
    that.getUserInfo();
    that.getCartInfo();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
  },
  methods: {
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.district = ret.itemName3;
    },
    getUserInfo() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
        })
        .catch(() => {});
    },
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
    },
    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        couponCode:this.couponCode,
        shipping_type: parseInt(shipping_type) + 1,
        payType: this.active
      }).then(res => {
        const data = res.data;
        if (data.status === "EXTEND_ORDER") {
          this.$router.replace({
            path: "/order/detail/" + data.result.orderId
          });
        } else {
          this.orderPrice = data.result;
        }
      })
      .catch(err => {
          console.log(err);
          this.$dialog.loading.close();
          this.$dialog.error(err.msg);
          if(err.msg == "使用的优惠码无效!"&&this.couponCode)
          {
            this.couponCode = '';
            this.computedPrice();
          }
        });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds, this.active)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.is_tuan = res.data.userInfo.tuan;
          // this.is_caigou = res.data.userInfo.caigou;
          this.is_caigou = this.$route.query.caigou == 1;
          if(this.is_caigou)
          {
            this.active = "offline_caigou";
          }
          else
          {
            this.active = this._isWeixin ? "weixin" : "weixin";
          }

          this.computedPrice();
          this.$dialog.loading.close();
        })
        .catch(() => {
          this.$dialog.loading.close();
          this.$dialog.error("加载订单数据失败，返回后重试");
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      if(this.active != 'weixin')
      {
        return this.$dialog.toast({ mes: "线下支付不能使用优惠劵" });
      }
      else{
        this.showCoupon = true;
      }
      
    },
    couponCodeTap: function() {
      if(this.active != 'weixin')
      {
        return this.$dialog.toast({ mes: "线下支付不能使用优惠码" });
      }
      else if(this.orderGroupInfo.cartInfo.length ==1 && this.orderGroupInfo.cartInfo[0].productInfo.id==71023)
      {
        this.showCouponCode = true;
      }
      else{
        return this.$dialog.toast({ mes: "结算商品不能使用优惠码" });
      }
      
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    changeCouponCode: function(code) {
      if (!code) {
        this.couponCode = '';
      } else {
        this.couponCode = code;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      //切换支付方式，微信正常，
      //单位团购：不使用优惠劵，不需要邮费
      //征订采购：不使用优惠劵，不需要邮费，使用原价计算
      if(this.active == index) return false;
      
      this.active = index;
      this.getCartInfo();
      // return this.$dialog.toast({ mes: index });
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
    },
    confirmCreateOrder() {
      if (this.active == "weixin" && this.is_tuan) {
        if (this.active == 'offline_tuan' || this.active == 'offline_caigou') { 

        } else {
          this.active = 'weixin';
        }
        
        if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
        if (!this.addressInfo.id && !this.shipping_type)
          return this.$dialog.toast({ mes: "请选择收货地址" });
        if (this.shipping_type) {
          if (
            (this.contacts === "" || this.contactsTel === "") &&
            this.shipping_type
          )
            return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
          if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
            return this.$dialog.toast({ mes: "请填写正确的手机号" });
          }
          if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
            return this.$dialog.toast({ mes: "请填写您的真实姓名" });
          }
        }
        this.$dialog.confirm({
          mes: "您可以线下支付",
          title: "提示",
          opts: [
            {
              txt: "微信支付",
              color: true,
              callback: () => {
                this.createOrder();
              }
            },
            {
              txt: "重新选择",
              color: false,
              callback: () => {}
            }
          ]
        });
      } else if(this.is_caigou){
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写收货人真实姓名" });
        }
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if(!this.address.district){
          return this.$dialog.toast({ mes: "请选择收货地区" });
        }
        if(!this.address.district){
          return this.$dialog.toast({ mes: "请选择收货地区" });
        }
        if(this.address_detail==""){
          return this.$dialog.toast({ mes: "请输入详细地址" });
        }
        if (this.school_name=="") return this.$dialog.toast({ mes: "请输入完整的学校名称" });
        this.$dialog.confirm({
          mes: this.address.province+this.address.city+this.address.district+this.address_detail+"<br />"+this.school_name+"<br />"+this.contacts+"<br />"+ this.contactsTel,
          title: "请确认学校地址",
          opts: [
            {
              txt: "确 认",
              color: true,
              callback: () => {
                this.createOrder();
              }
            },
            {
              txt: "取 消",
              color: false,
              callback: () => {}
            }
          ]
        });
      }
      else{
        if (this.active == 'offline_tuan' || this.active == 'offline_caigou') { 

        } else {
          this.active = 'weixin';
        }

        if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
        if (!this.addressInfo.id && !this.shipping_type)
          return this.$dialog.toast({ mes: "请选择收货地址" });
        if (this.shipping_type) {
          if (
            (this.contacts === "" || this.contactsTel === "") &&
            this.shipping_type
          )
            return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
          if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
            return this.$dialog.toast({ mes: "请填写正确的手机号" });
          }
          if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
            return this.$dialog.toast({ mes: "请填写您的真实姓名" });
          }
        }
        this.createOrder();
      }
    },
    createOrder() {
      let shipping_type = this.shipping_type;
      this.$dialog.loading.open("生成订单中");
      createOrder(this.orderGroupInfo.orderKey, {
        real_name: this.contacts,
        phone: this.contactsTel,
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        couponCode:this.couponCode,
        payType: this.active,
        pinkId: this.pinkId,
        seckill_id: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        mark: this.mark || "",
        school_name: this.school_name || "",
        province: this.address.province || "",
        city: this.address.city || "",
        district: this.address.district || "",
        address_detail: this.address_detail || "",
        shipping_type: parseInt(shipping_type) + 1
      })
        .then(res => {
          this.$dialog.loading.close();
          const data = res.data;
          let url = "/order/status/" + data.result.orderId;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              this.$router.replace({
                path: url + "/0?msg=" + res.msg
              });
              break;
            case "SUCCESS":
              this.$dialog.success(res.msg);
              this.$router.replace({
                path: url + "/1"
              });
              break;
            case "WECHAT_H5_PAY":
              this.$router.replace({
                path: url + "/2"
              });
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                this.$router.replace({
                  path: url + "/4"
                });
              });
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.loading.close();
          this.$dialog.error(err.msg || "创建订单失败");
        });
    }
  }
};
</script>
